import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import {
  generateIncludeQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import type { SingleBoardResponse } from 'types/Boards';
import type { BoardChat } from 'types/Chats/BoardChat';

const getBoards = (boardID: string | null | undefined) => {
  if (!boardID) {
    return Promise.reject('board ID can not be null');
  }
  const queryArray = [generateIncludeQuery(['boardChats.chat'])];
  const url = generateURL(SPARK_RESOURCE_TYPES.BOARDS, queryArray, boardID);
  return fetchWrapper<SingleBoardResponse>({
    url: url,
    method: 'GET',
  });
};

export function useBoardsByID(boardID: string | null | undefined) {
  const queryResult = useQuery(
    [SPARK_RESOURCE_TYPES.BOARDS, boardID],
    () => getBoards(boardID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`Failed to get Board: ${error.message}`);
        }
      },
      enabled: Boolean(boardID),
      ...CACHE_AND_STALE_TIME,
    }
  );

  const { data } = queryResult;
  const { data: board, included } = data || {};
  const boardChat = included?.find((item) => item.type === 'boardChats') as
    | BoardChat
    | undefined;

  return {
    board,
    boardChat,
    ...queryResult,
  };
}
